import { GlossaryStatus, GlossaryStatusEnum } from './enums/GlossaryStatusEnum';

export type Glossary = {
  id: string;
  userId: string;
  glossaryStatus: GlossaryStatus;
  modelId: string;
  createdUtc: string;
  updatedUtc: string;
  deletedUtc: string;
  languageIsoCode: string;
  name: string;
  replace: string;
  format: string;
  doNotTranslate: string;
  tokens: string;
  profanity: boolean;
};

export type Glossaries = Array<Glossary>;

export const DefaultGlossary: Glossary = {
  id: '',
  userId: '',
  glossaryStatus: GlossaryStatusEnum.CREATED,
  modelId: '',
  createdUtc: '',
  updatedUtc: '',
  deletedUtc: '',
  languageIsoCode: 'en-us',
  name: '',
  replace: '',
  format: '',
  doNotTranslate: '',
  tokens: '',
  profanity: false
};

export type DoNotTranslate = {
  phrase: string;
  match: boolean;
};

export type Format = {
  phrase: string;
  match: boolean;
};

export type Replace = {
  find: string;
  replace: string;
  match: boolean;
};

export type ClassToken = {
  phrase: string;
};
